import { Component } from '@angular/core';
import { SexualPerformanceComponent } from '@consultation-upsells/sexual-performance/sexual-performance.component';

@Component({
  selector: 'app-sexual-performance-hair-loss',
  imports: [SexualPerformanceComponent],
  templateUrl: './sexual-performance-hair-loss.component.html',
})
export class SexualPerformanceHairLossComponent {}
